import React, {Fragment} from 'react';

export default function(){
    return(
        <Fragment>
            <h1>Genomic Sequencing</h1>
            <p>
               
            </p>
            <p>
              
            </p>
        </Fragment>
    )
}